export const smoothOut =
  'linear(0, 0.005, 0.02 2.2%, 0.045, 0.081 4.9%, 0.16 7.3%, 0.465 16.2%, 0.561, 0.642,0.713 25.8%, 0.773, 0.825 32.7%, 0.868 36.5%, 0.905 40.9%, 0.935 45.7%,0.958 51.1%, 0.975 57.4%, 0.986 64.4%, 0.993 73.1%, 0.997 84.1%, 0.999)';

export const springOut =
  'linear( 0, 0.002, 0.008 1%, 0.032, 0.071, 0.128 4.3%, 0.256 6.5%, 0.672 12.9%, 0.788, 0.881, 0.959, 1.019 21%, 1.043, 1.064, 1.08, 1.093 25.2%, 1.105, 1.111, 1.112, 1.108 31.4%, 1.101, 1.092 34.5%, 1.039 41.7%, 1.017 45.5%, 1.007, 0.999, 0.994 51.8%, 0.99 54.1%, 0.988 57.1% 60.6%, 0.998 74%, 1.001 81.2% 100% )';

export const metaEaseIn = 'cubic-bezier(0.5, 0, 0.75, 0)';
export const metaEaseOut = 'cubic-bezier(0.25, 1, 0.5, 1)';
export const metaEaseInOut = 'cubic-bezier(0.76, 0, 0.24, 1)';
export const expoIn = 'cubic-bezier(0.7, 0, 0.84, 0)';
export const expoOut = 'cubic-bezier(0.16, 1, 0.3, 1)';
